import React from "react";

const PageFallback = () => {
  return (
    <div className="h-screen bg-white flex justify-center items-center">
      <span className="loader"></span>
    </div>
  );
};

export default PageFallback;
